angular
  .module('sms.common.services')
  .service('nameValidationService', nameValidation)

const NAME_REGEX = /^[^/\\:*?"<>|@,;]+$/

function nameValidation() {
  const service = {}
  service.pattern = NAME_REGEX
  return service
}
